import { ReactComponent as IconInfoBox } from './icon_info_box.svg';
import { ReactComponent as IconInfoBoxPlain } from './icon_info_box_plain.svg';
import { ReactComponent as IconInfoBoxSpeech } from './icon_info_box_speech.svg';
import { ReactComponent as IconInfoBoxSpeechTop } from './icon_info_box_speech_top.svg';
import { ReactComponent as IconInfoBoxSpeechLeft } from './icon_info_box_speech_left.svg';
import { ReactComponent as IconInfoBoxSpeechRight } from './icon_info_box_speech_right.svg';
import { ReactComponent as IconInfoBoxSpeechBottom } from './icon_info_box_speech_bottom.svg';
import { ReactComponent as IconInfoBoxNote } from './icon_info_box_note.svg';
import { ReactComponent as IconGrab } from './icon_grab.svg';
import { ReactComponent as IconGrabEmpty } from './icon_grab_empty.svg';
import { ReactComponent as IconBold } from './icon_bold.svg';
import { ReactComponent as IconItalic } from './icon_italic.svg';
import { ReactComponent as IconUnderline } from './icon_underline.svg';
import { ReactComponent as IconBulletList } from './icon_bullet_list.svg';
import { ReactComponent as IconNumberList } from './icon_number_list.svg';
import { ReactComponent as IconFont } from './icon_font.svg';
import { ReactComponent as IconQuestionMark } from 'approot/shared/icons/icon_question_mark.svg';
import { ReactComponent as IconClock } from './icon_clock.svg';
import { ReactComponent as IconExpandArrows } from './icon_expand_arrows.svg';
import { ReactComponent as IconPresent } from './icon_present.svg';
import { ReactComponent as IconLightBulb } from './icon_light_bulb.svg';
import { ReactComponent as IconAlignLeft } from './icon_align_left.svg';
import { ReactComponent as IconAlignCentre } from './icon_align_centre.svg';
import { ReactComponent as IconAlignRight } from './icon_align_right.svg';
import { ReactComponent as IconCorrect } from './icon_correct.svg';
import { ReactComponent as IconIncorrect } from './icon_incorrect.svg';
import { ReactComponent as IconPencil } from './icon_pencil.svg';
import { ReactComponent as IconHighlight } from './icon_highlight.svg';
import { ReactComponent as IconAlignTop } from './icon_align_top.svg';
import { ReactComponent as IconAlignBottom } from './icon_align_bottom.svg';
import { ReactComponent as IconAlignMiddle } from './icon_align_middle.svg';
import { ReactComponent as IconAlignDistribute } from './icon_align_distribute.svg';
import { ReactComponent as IconDevices } from './icon_devices.svg';
import { ReactComponent as IconEditActive } from './icon_pencil_active.svg';
import { ReactComponent as IconBookActive } from './icon_book_active.svg';
import { ReactComponent as IconPlusActive } from './icon_plus_active.svg';
import { ReactComponent as IconSettingsActive } from './icon_settings_active.svg';
import { ReactComponent as IconCrop } from './icon_crop.svg';
import { ReactComponent as IconPaintPallet } from './icon_paint_pallet.svg';
import { ReactComponent as IconPaintPalletActive } from './icon_paint_pallet_active.svg';
import { ReactComponent as IconRect } from './icon_rect.svg';
import { ReactComponent as IconSendEmail } from './icon_send_email.svg';
import { ReactComponent as IconHistory } from './icon_history.svg';
import { ReactComponent as IconShrink } from './icon_shrink.svg';
import { ReactComponent as IconContentAlignRight } from './icon_content_align_right.svg';
import { ReactComponent as IconContentAlignLeft } from './icon_content_align_left.svg';
import { ReactComponent as IconContentAlignCentre } from './icon_content_align_centre.svg';

export const inlineSvgMapping = {
  icon_info_box: IconInfoBox,
  icon_info_box_plain: IconInfoBoxPlain,
  icon_info_box_speech: IconInfoBoxSpeech,
  icon_info_box_speech_top: IconInfoBoxSpeechTop,
  icon_info_box_speech_left: IconInfoBoxSpeechLeft,
  icon_info_box_speech_right: IconInfoBoxSpeechRight,
  icon_info_box_speech_bottom: IconInfoBoxSpeechBottom,
  icon_info_box_note: IconInfoBoxNote,
  icon_grab: IconGrab,
  icon_grab_empty: IconGrabEmpty,
  icon_bold: IconBold,
  icon_italic: IconItalic,
  icon_underline: IconUnderline,
  icon_bullet_list: IconBulletList,
  icon_number_list: IconNumberList,
  icon_font: IconFont,
  icon_question_mark: IconQuestionMark,
  icon_clock: IconClock,
  icon_present: IconPresent,
  icon_expand_arrows: IconExpandArrows,
  icon_light_bulb: IconLightBulb,
  icon_align_left: IconAlignLeft,
  icon_align_centre: IconAlignCentre,
  icon_align_right: IconAlignRight,
  icon_correct: IconCorrect,
  icon_incorrect: IconIncorrect,
  icon_pencil: IconPencil,
  icon_highlight: IconHighlight,
  icon_align_top: IconAlignTop,
  icon_align_bottom: IconAlignBottom,
  icon_align_middle: IconAlignMiddle,
  icon_align_distribute: IconAlignDistribute,
  icon_devices: IconDevices,
  icon_pencil_active: IconEditActive,
  icon_book_active: IconBookActive,
  icon_plus_active: IconPlusActive,
  icon_settings_active: IconSettingsActive,
  icon_crop: IconCrop,
  icon_paint_pallet: IconPaintPallet,
  icon_paint_pallet_active: IconPaintPalletActive,
  icon_rect: IconRect,
  icon_send_email: IconSendEmail,
  icon_history: IconHistory,
  icon_shrink: IconShrink,
  icon_content_align_centre: IconContentAlignCentre,
  icon_content_align_left: IconContentAlignLeft,
  icon_content_align_right: IconContentAlignRight,
};

export type ActivityBuilderSvgIds = keyof typeof inlineSvgMapping;

type Props = {
  id: ActivityBuilderSvgIds;
  width?: string | number;
  height?: string | number;
  $rotate?: number;
};

const ActivityBuilderInlineSvg = ({
  id,
  width,
  height,
  $rotate,
  ...rest
}: Props) => {
  const Svg = inlineSvgMapping[id];
  return (
    <Svg
      focusable="false"
      width={width || 16}
      height={height || 16}
      style={
        $rotate
          ? {
              transform: `rotate(${$rotate}deg)`,
            }
          : {}
      }
      {...rest}
    />
  );
};

export default ActivityBuilderInlineSvg;
